<!--
 * @Author       : JiangChao
 * @Date         : 2021-07-01 10:38:18
 * @LastEditors  : JiangChao
 * @LastEditTime : 2021-07-27 22:29:20
 * @Description  : 示例报告
-->
<template>
  <div class="container" :style="{ minHeight: boxheight }">
    <div
      class="pdfList-box"
      v-for="(item, index) in pdfList"
      :key="index"
      @click="pdfRouter(item)"
    >
      <div class="left-layout">
        <img
          class="icon-pdf-style"
          :src="require('@/assets/icon/icon_pdf.png')"
        />
        <div class="pdf-desc">
          <div class="pdf-name">{{ item.fileName }}</div>
          <div class="pdf-size">{{ Math.round(item.fileSize / 1024) }}KB</div>
        </div>
      </div>

      <img
        class="icon-right-arrow-style"
        :src="require('@/assets/icon/icon_right_arrow.png')"
      />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import wx from "wx";
import Emkt from "../../emkt";

export default {
  name: "pdfList",
  data() {
    return {
      pdfList: "",
      pdfName: "",
      pdfSize: "",
      pdfType: "",
    };
  },
  methods: {
    pdfRouter(item) {
      wx.miniProgram.navigateTo({
        url:
          "/pages/pdf/pdfPage?pdfName=" +
          item.fileName +
          "&pdfSize=" +
          item.fileSize +
          "&pdfType=" +
          item.type,
      });
      console.log(
        "/pages/pdf/pdfPage?pdfName=" +
          item.fileName +
          "&pdfSize=" +
          item.fileSize +
          "&pdfType=" +
          item.type
      );
    },
  },
  props: ['type'],
  components: {},
  computed: {
    boxheight() {
      return `${window.innerHeight}px`;
    },
  },
  mounted() {},
  created() {
    if (this.type) {
      this.gcapi("getExampleReports", 1).then((res) => {
        if (res.body.code == 0) {
          this.pdfList = res.body.result;
        }
      })
    }else {
      this.gcapi("getExampleReports", 2).then((res) => {
        if (res.body.code == 0) {
          this.pdfList = res.body.result;
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.container {
  background: #fafafa;
  padding: 10px;
  .pdfList-box {
    border-radius: 10px;
    height: 80px;
    display: flex;
    background: #ffffff;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #efeef3;
    .left-layout {
      display: flex;
      flex-direction: row;
    }
    .pdf-desc {
      margin-left: 10px;

      display: flex;
      flex-direction: column;
    }
    .icon-pdf-style {
      width: 41px;
      margin-left: 15px;
      height: 43px;
    }
    .icon-right-arrow-style {
      width: 7px;
      height: 12px;
      margin-right: 15px;
    }
    .pdf-desc {
      .pdf-name {
        color: #424242;
        font-size: 12px;
        font-weight: 600;
        font-family: PingFangSC-Semibold, PingFang SC;
      }
      .pdf-size {
        color: #424242;
        font-size: 12px;
        font-weight: 600;
        font-family: PingFangSC-Semibold, PingFang SC;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// PdfList.vue?e156f7c4